import { useRoutes } from 'react-router-dom';
import AuthenticationRoutes from './AuthenticationRoutes';
import MainRoutesFunctional from './MainRoutes';
export default function ThemeRoutes({ isAuthenticated, setIsAuthenticated }: any) {
  const listRoute = MainRoutesFunctional({ isAuthenticated, setIsAuthenticated });
  return useRoutes(listRoute);
}
